document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.fsw-form').forEach(function (form) {
        form.addEventListener('submit', async function (e) {
            e.preventDefault();
            e.stopImmediatePropagation();

            // Через CartService (общая очередь): сброс корзины, если в ней что-то
            // есть, и один add.js. Раньше — clear.js + add.js сырыми fetch.
            const formData = new FormData(form);
            const variantId = Number(formData.get('id'));
            const quantity = Number(formData.get('quantity')) || 1;

            try {
                if (variantId) {
                    await window.CartService.prepareCheckout({
                        items: [{ variantId: variantId, quantity: quantity }],
                        clear: 'auto'
                    });
                }
            } catch (error) {
                console.error('Free bouquet: add to cart failed', error);
            }

            window.location.href = '/pages/free-bouquets';
        }, true);
    });
});
